import { a as _objectSpread2, _ as _objectWithoutPropertiesLoose } from '../_rollupPluginBabelHelpers-1f0bf8c2.js';
import { createComponent } from 'reakit-system/createComponent';
import { createHook } from 'reakit-system/createHook';
import 'reakit-utils/shallowEqual';
import '../Box/Box.js';
import { createContext, useMemo, useCallback, createElement } from 'react';
import 'reakit-utils/useLiveRef';
import 'reakit-utils/useIsomorphicEffect';
import 'reakit-utils/useSealedState';
import 'reakit-utils/applyState';
import '../Id/IdProvider.js';
import '../Id/IdState.js';
import { u as useCompositeState } from '../CompositeState-3a25dcee.js';
import '../Group/Group.js';
import 'reakit-utils/useUpdateEffect';
import 'reakit-utils/isPromise';
import 'reakit-utils/isEmpty';
import 'reakit-utils/isPlainObject';
import { unstable_useFormState } from './FormState.js';
import 'reakit-utils/isObject';
import './utils/setAllIn.js';
import './utils/getIn.js';
import 'reakit-utils/toArray';
import 'reakit-utils/isInteger';
import './utils/setIn.js';
import { g as getInputId } from '../getInputId-aa144169.js';
import '../getLabelId-3db05e97.js';
import '../shouldShowError-62b18bba.js';
import { unstable_useFormGroup } from './FormGroup.js';

var FormRadioGroupContext = createContext(null);
var unstable_useFormRadioGroup = createHook({
  name: "FormRadioGroup",
  compose: unstable_useFormGroup,
  useState: unstable_useFormState,
  keys: ["name"],
  useOptions: function useOptions(options, _ref) {
    var name = _ref.name;
    return _objectSpread2(_objectSpread2({}, options), {}, {
      name: options.name || name
    });
  },
  useProps: function useProps(options, _ref2) {
    var htmlWrapElement = _ref2.wrapElement,
        htmlProps = _objectWithoutPropertiesLoose(_ref2, ["wrapElement"]);

    var id = getInputId(options.name, options.baseId);
    var composite = useCompositeState({
      baseId: id,
      loop: true
    });
    var providerValue = useMemo(function () {
      return composite;
    }, Object.values(composite));
    var wrapElement = useCallback(function (element) {
      element = /*#__PURE__*/createElement(FormRadioGroupContext.Provider, {
        value: providerValue
      }, element);

      if (htmlWrapElement) {
        return htmlWrapElement(element);
      }

      return element;
    }, [providerValue, htmlWrapElement]);
    return _objectSpread2({
      role: "radiogroup",
      wrapElement: wrapElement
    }, htmlProps);
  }
});
var unstable_FormRadioGroup = createComponent({
  as: "fieldset",
  useHook: unstable_useFormRadioGroup
});

export { FormRadioGroupContext, unstable_FormRadioGroup, unstable_useFormRadioGroup };
